import { AvatarPreset, IDraftChracter } from "@/types";

import { getAvatarUrl } from "./getAvatarUrl";

export const getDraftCardsThumbnailImage = (draftValues: IDraftChracter[] | undefined): string[] | undefined => {
  if (!draftValues || draftValues.length === 0) {
    return;
  }
  return draftValues
    ?.slice(0, 4)
    .map((item: IDraftChracter) =>
      getAvatarUrl(item?.avatar_url ?? "", {
        preset: AvatarPreset.AVATAR_256X256,
      }),
    )
    .filter((url): url is string => !!url);
};
